// extracted by css-extract-rspack-plugin
export default {"lunchFlowSetupLayoutRoot":"uEkGhN"};